/* eslint-disable */
// import { PartsOrderStatusEnum } from '@/enums/PartsOrderStatusEnum'
// import qs from 'qs'
import {
  showErrorMessage,
  showSuccessMessage
} from '@/utils/createMessage'
import Api from '@/repository/index'
import moment from 'moment'
import { saveExcel } from '@/utils/saveExel'
import { Message } from 'element-ui'
const TOGGLE_LOADING = 'TOGGLE_LOADING'
const SET_SUPPLIERS = 'SET_SUPPLIERS'
const ADD_SUPPLIER = 'ADD_SUPPLIER'
const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER'
const DELETE_SUPPLIER = 'DELETE_SUPPLIER'
const SET_PARTS_ORDERS = 'SET_PARTS_ORDERS'
const ADD_PARTS_ORDER = 'ADD_PARTS_ORDER'
const DELETE_PARTS_ORDER = 'DELETE_PARTS_ORDER'
const UPDATE_PARTS_ORDER = 'UPDATE_PARTS_ORDER'
const TOGGLE_PARTS_ORDER_STATUS = 'TOGGLE_PARTS_ORDER_STATUS'
const SET_WAREHOUSE = 'SET_WAREHOUSE'
const ADD_TO_WAREHOUSE = 'ADD_TO_WAREHOUSE'
const UPDATE_WAREHOUSE = 'UPDATE_WAREHOUSE'
const DELETE_WAREHOUSE = 'DELETE_WAREHOUSE'
const SET_PART_CATEGORIES = 'SET_PART_CATEGORIES'
const ADD_PART_CATEGORY = 'ADD_PART_CATEGORY'
const UPDATE_PART_CATEGORY = 'UPDATE_PART_CATEGORY'
const DELETE_PART_CATEGORY = 'DELETE_PART_CATEGORY'
const SET_UNIT_MEASURE = 'SET_UNIT_MEASURE'
const SET_PARTS = 'SET_PARTS'
const ADD_PART = 'ADD_PART'
const UPDATE_PART = 'UPDATE_PART'
const DELETE_PART = 'DELETE_PART'
const SET_DECOMMISSION_PARTS = 'SET_DECOMMISSION_PARTS'
const DELETE_DECOMMISSION_PARTS = 'DELETE_DECOMMISSION_PARTS'
const SET_FILTERS = 'SET_FILTERS'
const SET_SCRAPPED_HISTORY = 'SET_SCRAPPED_HISTORY'
const SET_WAREHOUSE_ID = 'SET_WAREHOUSE_ID'
const SET_TRANSFER_REQ = 'SET_TRANSFER_REQ'
const SET_WAREHOUSE_ITEMS = 'SET_WAREHOUSE_ITEMS'
const SET_SCRAPPED_HISTORY_LIST = 'SET_SCRAPPED_HISTORY_LIST'
const SET_CURRENT_PART_ORDER = 'SET_CURRENT_PART_ORDER'
const SET_TOTAL_INVENTORY_VALUE = 'SET_TOTAL_INVENTORY_VALUE'

const state = {
  isLoading: true,
  suppliers: [],
  partsOrders: [],
  warehouse: [],
  parts: [],
  totalInventoryValue: 0,
  warehouseItems: [],
  decommissionParts: [],
  partCategories: [],
  scrappedHistory: [],
  transferRequests: [],
  scrappedHistoryList: [],
  warehouseId: undefined,
  filters: {
    supplier: '',
    supplierId: '',
    category: '',
    supplier_inn: '',
    vendorCode: '',
    unit: '',
    partPart: '',
    part: '',
    dateTime: [moment.utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'), moment.utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')],
    dateTimeByMonth: [moment.utc().subtract(1, 'month').startOf('month').format('YYYY-MM-DDT00:00:00[Z]'), moment.utc().startOf('month').format('YYYY-MM-DDT23:59:59[Z]')],
    providerName: '',
    specialization: '',
    name: '',
    invoiceNumber: '',
    scrappedHistoryCategories: [],
    scrappedHistorySuppliers: []
  },
  unitMeasure: [],
  currentPartOrder: {}
}
const utils = {
  async groupTransferHistoryList (scrappedHistoryList) {
    const getItemsNotNullable = scrappedHistoryList.filter(x => x?.hystoryItems?.length !== 0)
    const getReducedItems = getItemsNotNullable.reduce((acc, value) => {
      const getMappedData = value.hystoryItems.map((xy) => {
        return {
          ...xy,
          item: value.item
        }
      })
      acc = [...acc, ...getMappedData]
      // acc[value.item.id] = getMappedData
      return acc
    }, [])
    return getReducedItems.sort((a, b) => a.item.sparePartName - b.item.sparePartName)
  }
}
const mutations = {
  [TOGGLE_LOADING] (state, bool) {
    state.isLoading = bool
  },
  [SET_WAREHOUSE_ID] (state, id) {
    state.warehouseId = id
  },
  [SET_WAREHOUSE_ITEMS] (state, items) {
    state.warehouseItems = items
  },
  [SET_TRANSFER_REQ] (state, dta) {
    state.transferRequests = dta
  },
  [SET_SCRAPPED_HISTORY_LIST] (state, dta) {
    state.scrappedHistoryList = dta
  },
  [SET_SUPPLIERS] (state, suppliers) {
    state.suppliers = suppliers
  },
  [SET_SCRAPPED_HISTORY] (state, scrappedHistory) {
    state.scrappedHistory = scrappedHistory
  },
  [ADD_SUPPLIER] (state, supplier) {
    state.suppliers.push(supplier)
  },

  [UPDATE_SUPPLIER] (state, supplier) {
    const index = state.suppliers.findIndex(e => e.id === supplier.id)

    state.suppliers.splice(index, 1, supplier)
  },

  [DELETE_SUPPLIER] (state, supplierId) {
    const index = state.suppliers.findIndex(e => e.id === supplierId)

    state.suppliers.splice(index, 1)
  },

  [SET_PARTS_ORDERS] (state, partsOrders) {
    state.partsOrders = partsOrders
  },

  [ADD_PARTS_ORDER] (state, partsOrder) {
    state.partsOrders.push(partsOrder)
  },

  [UPDATE_PARTS_ORDER] (state, partsOrder) {
    const index = state.partsOrders.findIndex(e => e.id === partsOrder.id)

    state.partsOrders.splice(index, 1, partsOrder)
  },

  [DELETE_PARTS_ORDER] (state, orderId) {
    state.partsOrders = state.partsOrders.filter(e => e.id !== orderId)
  },

  [TOGGLE_PARTS_ORDER_STATUS] (state, { id, status }) {
    const index = state.partsOrders.findIndex(e => e.id === id)

    state.partsOrders.splice(index, 1, status)
  },

  [SET_WAREHOUSE] (state, warehouse) {
    state.warehouse = warehouse
    if (!state.warehouseId) {
      const getMainWarehouse = warehouse.find(x => x.isMain)
      if (!getMainWarehouse) {
        state.warehouseId = warehouse?.at(0)?.id
        return false
      }
      state.warehouseId = getMainWarehouse?.id
    }
  },

  [ADD_TO_WAREHOUSE] (state, part) {
    state.warehouse.unshift(part)
  },

  [UPDATE_WAREHOUSE] (state, part) {
    const index = state.warehouse.findIndex(e => e.id === part.id)

    state.warehouse.splice(index, 1, { ...state.warehouse[index], ...part })
  },

  [DELETE_WAREHOUSE] (state, partId) {
    state.warehouse = state.warehouse.filter(e => e.id !== partId)
  },

  [SET_UNIT_MEASURE] (state, unitMeasure) {
    state.unitMeasure = unitMeasure
  },

  [SET_PARTS] (state, parts) {
    state.parts = parts
  },

  [ADD_PART] (state, part) {
    state.parts.push(part)
  },

  [UPDATE_PART] (state, part) {
    const index = state.parts.findIndex(e => e.spare_part_id === part.spare_part_id)

    state.parts.splice(index, 1, part)
  },

  [DELETE_PART] (state, partId) {
    state.parts = state.parts.filter(e => e.spare_part_id !== partId)
  },

  [SET_PART_CATEGORIES] (state, categories) {
    state.partCategories = categories
  },

  [ADD_PART_CATEGORY] (state, category) {
    state.partCategories.push(category)
  },

  [DELETE_PART_CATEGORY] (state, categoryId) {
    state.partCategories = state.partCategories.filter(e => e.id !== categoryId)
  },
  [UPDATE_PART_CATEGORY] (state, { id, dto }) {
    const index = state.partCategories.findIndex(e => e.id === id)
    state.partCategories.splice(index, 1, { ...state.partCategories[index], ...dto })
  },
  [SET_DECOMMISSION_PARTS] (state, parts) {
    state.decommissionParts = parts
  },
  [DELETE_DECOMMISSION_PARTS] (state, id) {
    state.decommissionParts = state.decommissionParts.filter(e => e.id !== id)
  },
  [SET_FILTERS] (state, filters) {
    state.filters = filters
  },
  [SET_CURRENT_PART_ORDER] (state, order) {
    state.currentPartOrder = order
  },
  [SET_TOTAL_INVENTORY_VALUE] (state, value) {
    state.totalInventoryValue = value
  }
}

const actions = {
  async fetchSaveExelByDecommission ({ state }, params) {
    try {
      const { csv } = await Api.maintenance.decommissionpart.saveDecommissionPartsExel({
       warehouseId: state.warehouseId
      }, params.separator)

      saveExcel('отчет по водителям', csv)

      Message({
        message: 'Excel успешно скачан!',
        type: 'success',
        duration: 5 * 1000
      })

    } catch (e) {
      return Promise.reject(e)
    }
  },
  async fetchSaveExelByScrapped ({state}, params) {
    try {
      const { csv } = await Api.maintenance.movement.saveScrappedHistoryExel({
        warehouseId: state.warehouseId,
        startDate: state.filters.dateTime[0],
        endDate: state.filters.dateTime[1],
      }, params.separator)

      saveExcel('отчет по водителям', csv)

      Message({
        message: 'Excel успешно скачан!',
        type: 'success',
        duration: 5 * 1000
      })

    } catch (e) {
      return Promise.reject(e)
    }
  },
  async fetchSaveExelByMovement ({ state }, params) {
    try {
      debugger
      const { csv } = await Api.maintenance.movement.saveMovementHistoryExel({
        warehouseId: state.warehouseId,
        startDate: state.filters.dateTime[0],
        endDate: state.filters.dateTime[1],
      }, params.separator)

      saveExcel('отчет по водителям', csv)

      Message({
        message: 'Excel успешно скачан!',
        type: 'success',
        duration: 5 * 1000
      })

    } catch (e) {
      return Promise.reject(e)
    }
  },
  async setWarehouseId ({ commit }, id) {
    commit(SET_WAREHOUSE_ID, id)
  },
  async getTransfers ({ commit, state, dispatch }) {
    try {
      const getApproved = await Api.maintenance.transferReqs.getTransfers({ approved: true })
      const getNotApproved = await Api.maintenance.transferReqs.getTransfers({ actual: true, approved: false })
      const getItemIds = [getApproved, getNotApproved].flatMap(x => x.itemIds)
      const parts = await Api.maintenance.warehouseItem.getWarehouseItems({ item_ids: getItemIds, isZero: true })
      const getMappedTransfersApproved = getApproved.map(x => {
        const itemIds = x.items.map(x => x.id)
        return {
          ...x,
          items_data: parts.filter(y => itemIds?.some(xy => xy === y.id)).map(abc => {
            return {
              ...abc,
              itm: x.items.find(itm => itm.id === abc.id)
            }
          })
        }
      })
      const getMappedTransfersNotApproved = getNotApproved.map(x => {
        const itemIds = x.items.map(x => x.id)
        return {
          ...x,
          items_data: parts.filter(y => itemIds?.some(xy => xy === y.id)).map(abc => {
            return {
              ...abc,
              itm: x.items.find(itm => itm.id === abc.id)
            }
          })
        }
      })
      commit(SET_TRANSFER_REQ, {
        approved: getMappedTransfersApproved,
        notApproved: getMappedTransfersNotApproved
      })
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async deleteTransfer ({ commit, dispatch }, id) {
    try {
      await Api.maintenance.transferReqs.deleteTransfer({ id })
      await dispatch('getTransfers')
      showSuccessMessage('Успех!')
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async createTransfer ({ commit, dispatch }, data) {
    try {
      await Api.maintenance.transferReqs.createTransfer(data)
      await dispatch('getTransfers')
      showSuccessMessage('Успех!')
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateTransfer ({ commit, dispatch }, data) {
    try {
      await Api.maintenance.transferReqs.updateTransfer(data)
      await dispatch('getTransfers')
      showSuccessMessage('Успех!')
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async approveTransfer ({ commit, dispatch }, id) {
    try {
      await Api.maintenance.transferReqs.approveTransfer(id)
      await dispatch('getTransfers')
      showSuccessMessage('Успех!')
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async fetchSuppliers ({ commit }) {
    try {
      commit(TOGGLE_LOADING, true)
      const suppliers = await Api.maintenance.supplier.getSuppliers()

      commit(SET_SUPPLIERS, suppliers)
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async fetchTransferHistoryList ({ commit, state }) {
    try {
      const scrappedHistoryList = await Api.maintenance.index.getTransferHistoryList({
        warehouseId: state.warehouseId,
        date: state.filters.dateTimeByMonth
      })
      const getUtilResult = await utils.groupTransferHistoryList(scrappedHistoryList)
      commit(SET_SCRAPPED_HISTORY_LIST, getUtilResult)
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async fetchScrappedHistory ({ commit, state }, { startDate, endDate }) {
    try {
      commit(TOGGLE_LOADING, true)
      const scrappedHistory = await Api.maintenance.movement.getScrappedHistory({ startDate, endDate, warehouseId: state.warehouseId })
      commit(SET_SCRAPPED_HISTORY, scrappedHistory)
      commit(TOGGLE_LOADING, false)
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async fetchScrappedHistoryByWarehouseItemId ({ commit }, { startDate, endDate, warehouseItemId }) {
    try {
      return await Api.maintenance.movement.getScrappedHistoryByWarehouseItemId({ startDate, endDate, warehouseItemId })
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async fetchMovementHistoryByWarehouseItemId ({ state }, { warehouseItemId, startDate, endDate }) {
    try {
      return await Api.maintenance.movement.getMovementHistoryByWarehouseItemId({ warehouseItemId, startDate, endDate })
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async fetchMovementHistory ({ state }, _2) {
    try {
      const [startDate, endDate] = state.filters?.dateTime
      return await Api.maintenance.movement.getMovementHistory({ warehouseId: state.warehouseId, startDate, endDate })
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async fetchSupplierById ({ commit }, id) {
    try {
      const supplier = await Api.maintenance.supplier.getSupplierById(id)
      return supplier
    } catch (err) {
      showErrorMessage('Не удалось загрузить данные поставщика')
      return Promise.reject(err)
    }
  },

  async createSupplier ({ commit, dispatch }, supplierDto) {
    try {
      await Api.maintenance.supplier.createSupplier({
        ...supplierDto,
        bindingCategories: supplierDto.categories
      })
      await dispatch('fetchSuppliers')
      showSuccessMessage('Поставщик создан')
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async returnDecommissionPart ({ commit, dispatch }, id) {
    try {
      await Api.maintenance.decommissionpart.deleteDecommissionPart(id)
      await dispatch('fetchDecommissionParts')
      showSuccessMessage('Запчасть(-и) возвращены на склад')
      return {
        success: true
      }
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async updateSupplier ({ commit, dispatch }, supplierDto) {
    try {
      await Api.maintenance.supplier.updateSupplier({
        ...supplierDto,
        bindingCategories: supplierDto.categories
      })
      await dispatch('fetchSuppliers')
      showSuccessMessage('Поставщик обновлен')
    } catch (err) {
      showErrorMessage('Не удалось обновить поставщика')
      return Promise.reject(err)
    }
  },

  async deleteSupplier ({ dispatch }, supplierId) {
    try {
      const { message, success } = await Api.maintenance.supplier.deleteSupplier({ supplierId })
      if (!success) {
        return showErrorMessage(message || 'Не удалось обновить поставщика')
      }
      await dispatch('fetchSuppliers')
      showSuccessMessage('Поставщик удален')
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },

  async fetchPartsOrders ({ commit }) {
    try {
      commit(TOGGLE_LOADING, true)
      const partsOrders = await Api.maintenance.orders.getOrders()
      commit(SET_PARTS_ORDERS, partsOrders)
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },

  async createPartsOrder ({ dispatch }, dto) {
    try {
      await Api.maintenance.orders.createOrder(dto)
      await dispatch('fetchPartsOrders')
      showSuccessMessage('Заказ создан')
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },

  async updatePartsOrder ({ dispatch }, partsOrder) {
    try {
      await Api.maintenance.orders.updateOrder(partsOrder)
      await dispatch('fetchPartsOrders')
      showSuccessMessage('Заказ обновлен')
    } catch (err) {
      showErrorMessage('Заказ не удалось обновить')
      return Promise.reject(err)
    }
  },

  async deletePartsOrder ({ dispatch }, orderId) {
    try {
      await Api.maintenance.orders.deleteOrder(orderId)
      await dispatch('fetchPartsOrders')
      showSuccessMessage('Заказ удален')
    } catch (err) {
      showErrorMessage('Не удалось удалить заказ')
      return Promise.reject(err)
    }
  },

  async fetchPartsOrderById ({ commit }, partsOrderId) {
    try {
      return await Api.maintenance.orders.getOrderById(partsOrderId)
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },
  async getTransferHistoryByWarehouseItemId (_, id) {
    try {
      const getHistory = await Api.maintenance.index.getTransferHistoryByWarehouseItemId(id)
      const getLatestItem = getHistory.at(-1)
      const getTotalCount = getHistory?.length

      return getHistory.map((x, idx) => {
        const getRealTotalCount = () => {
          if (getTotalCount === 1) {
            return true
          }
          return idx === (getTotalCount - 1)
        }
        return {
          ...x,
          remainingQuantity: getRealTotalCount() ? getLatestItem?.remainingQuantity : 0,
          quantity: getLatestItem?.quantity,
          totalPriceSum: getLatestItem?.totalPriceSum
        }
      })
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },

  async acceptPartsOrder ({ dispatch }, partsOrderId) {
    try {
      await Api.maintenance.orders.acceptOrder(partsOrderId)
      await dispatch('fetchPartsOrders')
      // if (success) {
      //   commit(TOGGLE_PARTS_ORDER_STATUS, {
      //     status: PartsOrderStatusEnum.arrived,
      //     id: partsOrderId
      //   })
      // }

      showSuccessMessage('Заказ принят')
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },

  async fetchWarehouse ({ commit }) {
    try {
      const warehouse = await Api.maintenance.warehouse.getWarehouses()

      commit(SET_WAREHOUSE, warehouse)
      return warehouse
    } catch (err) {
      showErrorMessage('Не удалось загрузить склад')
      return Promise.reject(err)
    }
  },

  async fetchWarehouseById ({ commit }, id) {
    try {
      const warehouse = await Api.maintenance.warehouse.getWarehouseById({ id })

      return warehouse[0]
    } catch (err) {
      showErrorMessage('Не удалось загрузить склад')
      return Promise.reject(err)
    }
  },

  async createWarehouse ({ commit, dispatch }, DTO) {
    try {
      await Api.maintenance.warehouse.createWarehouse(DTO)
      await dispatch('fetchWarehouse')
      // commit(ADD_TO_WAREHOUSE, warehouse)

      showSuccessMessage('Склад создан!')
    } catch (err) {
      showErrorMessage('Не удалось создать склад!')
      return Promise.reject(err)
    }
  },

  async updateWarehouse ({ dispatch }, DTO) {
    try {
      await Api.maintenance.warehouse.updateWarehouse(DTO)
      await dispatch('fetchWarehouse')
      showSuccessMessage('Позиция обновлена')
    } catch (err) {
      showErrorMessage('Не удалось обновить позицию склада')
      return Promise.reject(err)
    }
  },

  async deleteWarehouse ({ dispatch }, id) {
    try {
      await Api.maintenance.warehouse.deleteWarehouse({ id })
      await dispatch('fetchWarehouse')
      showSuccessMessage('Cклад удален')
    } catch (err) {
      showErrorMessage('Не удалось удалить склад!!!!')
      return Promise.reject(err)
    }
  },

  async fetchPartCategories ({ commit }) {
    try {
      const categories = await Api.maintenance.sparePartCategory.getSparePartCategories()

      commit(SET_PART_CATEGORIES, categories)
    } catch (err) {
      showErrorMessage('Не удалось загрузить категории')
      return Promise.reject(err)
    }
  },

  async createPartCategory ({ dispatch }, categoryName) {
    try {
      await Api.maintenance.sparePartCategory.createSparePartCategory({ name: categoryName })
      await dispatch('fetchPartCategories')
      showSuccessMessage('Категория создана')
    } catch (err) {
      showErrorMessage('Не удалось создать категорию')
      return Promise.reject(err)
    }
  },

  async deletePartCategory ({ dispatch }, categoryId) {
    try {
      await Api.maintenance.sparePartCategory.deleteSparePartCategory({ sparePartCategoryId: categoryId })
      await dispatch('fetchPartCategories')
      showSuccessMessage('Категория удалена')
    } catch (err) {
      showErrorMessage('Не удалось удалить категорию')
      return Promise.reject(err)
    }
  },
  async updatePartCategory ({ dispatch }, { id: sparePartCategoryId, dto }) {
    try {
      await Api.maintenance.sparePartCategory.updateSparePartCategory({ sparePartCategoryId, ...dto })
      await dispatch('fetchPartCategories')
      showSuccessMessage('Категория измененна')
    } catch (err) {
      showErrorMessage('Не удалось изменить категорию')
      return Promise.reject(err)
    }
  },
  async fetchUnitMeasure ({ commit }) {
    try {
      const unitMeasure = await Api.maintenance.index.getMeasureUnits()
      commit(SET_UNIT_MEASURE, unitMeasure)
    } catch (err) {
      showErrorMessage('Не удалось загрузить единицы измерения')
      return Promise.reject(err)
    }
  },

  async fetchWarehouseItemsById ({ commit, state }, warehouseId) {
    try {
      return await Api.maintenance.warehouseItem.getWarehouseItems({ warehouseId: warehouseId })
    } catch (err) {
      showErrorMessage('Не удалось загрузить запчасти склада')
      return Promise.reject(err)
    }
  },

  async fetchWarehouseItems ({ commit, state }, params) {
    try {
      commit(TOGGLE_LOADING, true)
      const getParams = (paramsArgs) => {
        if (paramsArgs?.isFreaze) {
          return { ...paramsArgs, isFreaze: undefined }
        }
        return paramsArgs
      }
      const parts = await Api.maintenance.warehouseItem.getWarehouseItems({ warehouseId: state.warehouseId, ...getParams(params) })
      if (params?.isFreaze) {
        const partsFreaze = await Api.maintenance.index.getMaintenanceFreezeItems({ warehouseId: state.warehouseId, isZero: true })
        const getMappedFreze = partsFreaze.map((x) => {
          return {
            ...x,
            freze: true
          }
        })

        return commit(SET_WAREHOUSE_ITEMS, [...parts, ...getMappedFreze])
      }

      commit(SET_WAREHOUSE_ITEMS, [...parts])
    } catch (err) {
      showErrorMessage('Не удалось загрузить запчасти')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async getMaintenanceFreezeItems ({ commit, state }, params) {
    try {
      const parts = await Api.maintenance.warehouseItem.getMaintenanceFreezeItems({ warehouseId: state.warehouseId })
      // commit(SET_WAREHOUSE_ITEMS, [...state.warehouseItems, ...parts])
      return parts
    } catch (err) {
      showErrorMessage('Не удалось загрузить запчасти')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async fetchWarehouseItemsIds ({ commit, state }, params) {
    try {
      // const newPrams = qs.stringify(params, { arrayFormat: 'repeat' })
      const parts = await Api.maintenance.warehouseItem.getWarehouseItems({ ...params })
      return parts
    } catch (err) {
      showErrorMessage('Не удалось загрузить запчасти')
      return Promise.reject(err)
    }
  },
  async moveWarehouseItem ({ dispatch, state }, data) {
    try {
      await Api.maintenance.warehouseItem.warehouseItemMove(data)
      await dispatch('fetchWarehouseItems')
      showSuccessMessage('Успешно')
    } catch (err) {
      showErrorMessage('Не удалось загрузить запчасти')
      return Promise.reject(err)
    }
  },
  async createWarehouseItem ({ dispatch, state }, data) {
    try {
      await Api.maintenance.warehouseItem.createWarehouseItem(data)
      await dispatch('fetchWarehouseItems')
      showSuccessMessage('Успешно')
    } catch (err) {
      showErrorMessage('Не удалось загрузить запчасти')
      return Promise.reject(err)
    }
  },

  async updateWarehouseItem ({ dispatch, state }, data) {
    try {
      await Api.maintenance.warehouseItem.updateWarehouseItem(data)
      await dispatch('fetchWarehouseItems')
      showSuccessMessage('Успешно')
    } catch (err) {
      showErrorMessage('Не удалось загрузить запчасти')
      return Promise.reject(err)
    }
  },

  async updateWarehouseItems (_, array) {
    try {
      return await Api.maintenance.warehouseItem.updateWarehouseItems({
        warehouseItems: array
      })
    } catch (err) {
      showErrorMessage('Не удалось загрузить запчасти')
      return Promise.reject(err)
    }
  },

  async deleteWarehouseItem ({ commit }, id) {
    try {
      await Api.maintenance.warehouseItem.deleteWarehouseItem(id)
    } catch (err) {
      return Promise.reject(err)
    }
  },

  async fetchParts ({ commit, state }) {
    try {
      commit(TOGGLE_LOADING, true)
      const parts = await Api.maintenance.sparePart.getSpareParts()
      commit(SET_PARTS, parts.spareParts)
      commit(SET_TOTAL_INVENTORY_VALUE, parts.totalInventoryValue)
    } catch (err) {
      showErrorMessage('Не удалось загрузить запчасти')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async createPart ({ commit, dispatch }, partDto) {
    try {
      await Api.maintenance.sparePart.createSparePart(partDto)
      await dispatch('fetchParts')
      showSuccessMessage('Запчасть создана')
    } catch (err) {
      showErrorMessage('Не удалось создать запчасть')
      return Promise.reject(err)
    }
  },

  async updatePart ({ commit, dispatch }, partDto) {
    try {
      await Api.maintenance.sparePart.updateSparePart(partDto)
      await dispatch('fetchParts')
      showSuccessMessage('Запчасть обновлена')
    } catch (err) {
      showErrorMessage('Не удалось обновить запчасть')
      return Promise.reject(err)
    }
  },

  async deletePart ({ dispatch }, sparePartId) {
    try {
      await Api.maintenance.sparePart.deleteSparePart({ sparePartId })
      await dispatch('fetchParts')
      showSuccessMessage('Запчасть удалена')
    } catch (err) {
      showErrorMessage('Не удалось удалить запчасть')
      return Promise.reject(err)
    }
  },

  async fetchDecommissionParts ({ commit, state }) {
    try {
      const parts = await Api.maintenance.decommissionpart.getDecommissionParts({ warehouseId: state.warehouseId })

      commit(SET_DECOMMISSION_PARTS, parts)
    } catch (err) {
      showErrorMessage('Не удалось загрузить списанные запчасти')
      return Promise.reject(err)
    }
  },

  async decommissionPart ({ commit }, partDto) {
    try {
      await Api.maintenance.decommissionpart.createDecommissionPart(partDto)
      showSuccessMessage('Запчасть списана')
    } catch (err) {
      showErrorMessage('Не удалось списать запчасть')
      return Promise.reject(err)
    }
  },
  async getFilteredSuppliers ({ state }, supplierId) {
    // if (state.filters.supplierId === '') return
    const response = await Api.maintenance.warehouseItem.getWarehouseItems({ warehouseId: state.warehouseId, supplierId: supplierId })
    state.warehouseItems = response
  },
  async getMaintenance () {
    const response = await Api.maintenance.warehouseItem.getWarehouseItems({})
    state.warehouseItems = response
  },

  setFilters ({ commit }, filters) {
    commit(SET_FILTERS, filters)
  },

  setCurrentPartOrder ({ commit }, order) {
    commit(SET_CURRENT_PART_ORDER, order)
  }
}

const getters = {
  getWarehouseItemById (state) {
    return (id) => {
      return state.warehouse.find(x => x.id === id)
    }
  },

  filtredPartsOrders (state) {
    const supplier = state.filters.supplier
    if (!supplier) return state.partsOrders
    return state.partsOrders.filter(e => e.supplierId.includes(supplier))
  },
  filtredSuppliers (state) {
    const { supplier, supplier_inn } = state.filters
    let data = state.suppliers
    if (supplier) {
      data = data.filter(e => e.supplierId.includes(supplier))
    }
    if (supplier_inn) {
      data = data.filter(e => e.inn === supplier_inn)
    }
    return data
  },
  getWarehousesProviders (stage) {
    return [...new Set(stage.warehouse.map(x => x.providerName))]
  },
  getWarehousesSpecialization (stage) {
    return [...new Set(stage.warehouse.map(x => x.specialization))]
  },
  getWarehousesNames (stage) {
    return [...new Set(stage.warehouse.map(x => x.name))]
  },
  filtredWarehouse (state) {
    let getStateWarehouses = state.warehouse
    const { providerName, specialization, name } = state.filters
    if (providerName) {
      getStateWarehouses = getStateWarehouses.filter(e => e.providerName === providerName)
    }
    if (specialization) {
      getStateWarehouses = getStateWarehouses.filter(e => e.specialization === specialization)
    }
    if (name) {
      getStateWarehouses = getStateWarehouses.filter(e => e.name === name)
    }
    return getStateWarehouses
  },
  filtredTransferReqs (state) {
    return state.transferRequests
  },

  getDecommissionPartsPartName (state) {
    return [...new Set([...state.decommissionParts.map(x => x.sparePartName), ...state.scrappedHistory.map(x => x.sparePartName)])]
  },
  getDecommissionPartsSupplierName (state) {
    return [...new Set(state.decommissionParts.map(x => x.supplierName))]
  },
  getDecommissionPartsVendorCode (state) {
    return [...new Set(state.decommissionParts.map(x => x.vendorCode))]
  },
  getDecommissionPartsInvoiceNumber (state) {
    return [...new Set(state.decommissionParts.map(x => x.invoiceNumber))]
  },
  filteredManualDecommissionParts (state) {
    let getStateDecommissionParts = state.decommissionParts
    const { part, supplier, vendorCode, invoiceNumber } = state.filters
    if (part) {
      getStateDecommissionParts = getStateDecommissionParts.filter(x => x.sparePartName === part)
    }
    if (supplier) {
      getStateDecommissionParts = getStateDecommissionParts.filter(x => x.supplierName === supplier)
    }
    if (vendorCode) {
      getStateDecommissionParts = getStateDecommissionParts.filter(x => x.vendorCode === vendorCode)
    }
    if (invoiceNumber) {
      getStateDecommissionParts = getStateDecommissionParts.filter(x => x.invoiceNumber === invoiceNumber)
    }
    return getStateDecommissionParts
  },
  filteredDecommissionParts (state) {
    let getStateDecommissionParts = state.scrappedHistory
    const { part } = state.filters
    if (part) {
      getStateDecommissionParts = getStateDecommissionParts.filter(x => {
        return x.sparePartName === part
      })
    }
    return getStateDecommissionParts
  },
  filtredPartCategories (state) {
    const category = state.filters.category
    return state.partCategories.filter(e => e.sparePartCategoryId.includes(category))
  },
  getWarehousesItemsPartNames (state) {
    return [...new Set(state.warehouseItems.map(x => x.sparePartName))]
  },
  getWarehousesItemsVendorCode (state) {
    return [...new Set(state.warehouseItems.map(x => x.sparePartVendorCode))]
  },
  getWarehousesItemsUnit (state) {
    return [...new Set(state.warehouseItems.map(x => x.unitMeasureName))]
  },
  getWarehousesItemsCategories (state) {
    return [...new Set(state.warehouseItems.flatMap(x => x.sparePartCategories).map(y => y.name))]
  },
  getWarehouseItemsProvider (state) {
    return [...new Set(state.warehouseItems.map(x => x.supplierName))]
  },
  filtredWarehouseItems (state) {
    let getStateWarehouseItems = state.warehouseItems
    const { vendorCode, part, unit, category } = state.filters
    if (vendorCode) {
      getStateWarehouseItems = getStateWarehouseItems.filter(x => x.sparePartVendorCode === vendorCode)
    }
    if (part) {
      getStateWarehouseItems = getStateWarehouseItems.filter(x => x.sparePartName === part)
    }
    if (unit) {
      getStateWarehouseItems = getStateWarehouseItems.filter(x => x.unitMeasureName === unit)
    }
    if (category) {
      getStateWarehouseItems = getStateWarehouseItems.filter(x => x?.sparePartCategories?.some(y => y?.name === category))
    }
    return getStateWarehouseItems
  },
  filtredParts (state) {
    let getStateParts = state.parts
    const { partPart, category } = state.filters
    if (partPart) {
      getStateParts = getStateParts.filter(x => x.sparePartId === partPart)
    }
    if (category) {
      getStateParts = getStateParts.filter(x => x.bindingCategories.some(x => x.sparePartCategoryId === category))
    }
    return getStateParts
  },

  getPartOrdersByStatus (state, getters) {
    return (orderStatus) => {
      return getters.filtredPartsOrders.filter(e => e.status === orderStatus)
    }
  },
  getTransfersByApprovedStatus (state) {
    return (status) => {
      return state.transferRequests.filter(e => e.approved === status)
    }
  },
  getPartsByCategory (state) {
    return (categoryId) => {
      return state.parts.filter(part => {
        return part.bindingCategories
          .map(category => category.sparePartCategoryId)
          .includes(categoryId)
      }) || []
    }
  },

  partCategoriesTranslate (state) {
    return state.partCategories.reduce((acc, e) => {
      acc[e.id] = e.name
      return acc
    }, {})
  },

  unitMeasureTranslate (state) {
    return state.unitMeasure.reduce((acc, e) => {
      acc[e.id] = e.name
      return acc
    }, {})
  },

  getSupplierInns (state) {
    return [...new Set(state.suppliers.map(x => x.inn))]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
